module.exports = __webpack_public_path__ + "img/3Dline_example.30ec4b9e.png";